import React, { useState } from 'react';
import { Form, Button, Container, Alert } from 'react-bootstrap';
import { useNavigate, Link } from 'react-router-dom';
import config from '../config';

const server_URL = config.SERVER_URL;

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    const inputs = {
      method: 'login',
      email,
      password,
    };

    try {
      const response = await fetch(`${server_URL}/api/auth`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(inputs)
      });
      const data = await response.json();

      if (data.status === "1") {
        // Store user data including subuser info if applicable
        localStorage.setItem('user', JSON.stringify(data.data.user));
        localStorage.setItem('isAuthenticated', true);
        // Store modules if it's a subuser
        if (data.data.user.is_subuser && data.data.user.modules) {
          localStorage.setItem('subuser_modules', JSON.stringify(data.data.user.modules));
        }
        window.location.reload('/');
      } else {
        setError(data.error);
      }
    } catch (error) {
      console.error('Error during login:', error);
      setError('An error occurred during login');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Container className="mt-5" style={{ maxWidth: '400px' }}>
      <h2 className="mb-4 text-center">Login</h2>
      
      {error && (
        <Alert 
          variant="danger" 
          className="mb-4 text-center"
          style={{
            position: 'relative',
            animation: 'fadeIn 0.5s'
          }}
        >
          <i className="fas fa-exclamation-circle me-2"></i>
          {error}
        </Alert>
      )}

      <Form onSubmit={handleSubmit} className="bg-white p-4 rounded shadow-sm">
        <Form.Group className="mb-3">
          <Form.Label>Email address</Form.Label>
          <Form.Control
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            disabled={isLoading}
            placeholder="Enter your email"
          />
        </Form.Group>

        <Form.Group className="mb-4">
          <Form.Label>Password</Form.Label>
          <Form.Control
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            disabled={isLoading}
            placeholder="Enter your password"
          />
        </Form.Group>

        <Button 
          variant="primary" 
          type="submit" 
          className="w-100 mb-3" 
          disabled={isLoading}
        >
          {isLoading ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              Logging in...
            </>
          ) : (
            'Login'
          )}
        </Button>

        {/* <p className="mt-3 text-center mb-0">
          Don't have an account? <Link to="/register">Register here</Link>
        </p> */}
      </Form>
    </Container>
  );
}

const styles = `
  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(-10px); }
    to { opacity: 1; transform: translateY(0); }
  }
`;

const styleSheet = document.createElement("style");
styleSheet.innerText = styles;
document.head.appendChild(styleSheet);

export default Login; 